export const getQueryParams = state => state.router.location.search;
export const emailPreference = state => state.marketingPreferences.email;
export const directMailPreference = state => state.marketingPreferences.directMail;
export const isLoggedIn = state => state.loggedIn;
